import { render, staticRenderFns } from "./controlCase.vue?vue&type=template&id=c2060366&scoped=true&"
import script from "./controlCase.vue?vue&type=script&lang=js&"
export * from "./controlCase.vue?vue&type=script&lang=js&"
import style0 from "./controlCase.vue?vue&type=style&index=0&id=c2060366&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2060366",
  null
  
)

export default component.exports